module.exports = __webpack_public_path__ + "assets/img/loginBg.bf270607.png";